import { Container } from "./styled";

const Contents = (props) => {
  return <Container>{props.children}</Container>;
};

export default Contents;
